import { render, staticRenderFns } from "./limitnumbers.vue?vue&type=template&id=47e47722&scoped=true&"
import script from "./limitnumbers.vue?vue&type=script&lang=js&"
export * from "./limitnumbers.vue?vue&type=script&lang=js&"
import style0 from "./limitnumbers.vue?vue&type=style&index=0&id=47e47722&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47e47722",
  null
  
)

export default component.exports